//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion

//#region IMR Imports

import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'
import { BUTTON_COMPONENT_NAME } from '@imr/controls.angularjs/components/button'
import { IMRButtonListItem } from '@imr/controls.angularjs/components/button-list'
import { IMRButtonListPopupOptions, IIMRButtonListPopup } from '@imr/controls.angularjs/components/button-list/popup'

//#endregion

import { LocalDictionaryFactory } from '../../../api/api.module'
import { ColumnModel } from '../../../api/api.models'
import { ColumnInfo } from '../../../../models/custom'

import { ActionHelper } from '../../../../helpers/action-helper'
import { EventsNames, LocalizationHelper, TemplateHelper, ConfigHelper, OperatorLayoutSettings, ToastHelper, LogHelper, TypeHelper, CommonHelper } from '../../../../helpers'

import { DepositoryService } from '../../../../services/depository'
import { DeviceService } from '../../../../services/device'
import { OperatorDepositoryService, OperatorService, OperatorTechnicalPermissionsService } from '../../../../services/operator'
import { CreateEditResult, SystemService } from '../../../../services/system'
import { UserSessionService } from '../../../../services/user-session'

import { Activity, Enums } from '../../../../models/common'
import { OpOperator, OpDataTypeInGroup, OpLocationEquipment, OpDevice, OpData, OpLocation, OpTechnicalPermission, OpOperatorTechnicalPermission } from '../../../../models/core'

import { ActionStatusOptions } from '../../../common/action-status/action-status.controller'
import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../../common/common.details'
import { DetailsParametersOptions } from '../../../common/details-parameters/details-parameters.directive'
import { DetailsOptions } from '../../../common/details-popup/details-popup.directive'
import { GridTypes, GridOptions, GridController } from '../../../common/grid'
import { InfoPopupSource } from '../../../common/info-popup/info-popup.directive'
import { SourcePopover } from '../../../common/select-box-popup/select-box-popup.directive'
import { ItemSwapperResult, IItemSwapperPopup, ItemSwapperPopupOptions } from '../../../common/item-swapper'
import { DetailsPopupTabSelectedArgs, DetailsPopupOptions } from '../../../common/details-popup'
import { CreateEditInitParams } from '../../../common/create-edit-popup/create-edit-popup.controller'
import { GridBridge } from '../../../common/common.interfaces'
import { TreeListOptions } from '../../../common/tree-list/tree-list.controller'
import { IMRDepositoryParametersOptions } from '../../../common/depository-parameters'
import { IMRConfirmationPopupOptions, IIMRConfirmationPopup, IMRConfirmationPopupInitializedArgs } from '../../../common/confirmation-popup2'

import { OperatorDetailsNotificationsOptions, OperatorDetailsNotificationsOperatorSavedArgs } from './components/notifications'
import { OperatorDetailsSecurityOptions, OperatorDetailsSecurityOperatorSavedArgs } from './components/security'


interface OperatorDetailsScope extends DetailsScope {
    id: number
}

export class OperatorDetailsDirectiveController extends Details<OperatorDetailsScope> {

    //#region Consts

    public get OPERATOR_COMMON_TAB_NAME(): string { return 'OPERATOR_COMMON_TAB_NAME' }
    public get OPERATOR_SECURITY_TAB_NAME(): string { return 'OPERATOR_SECURITY_TAB_NAME' }
    public get OPERATOR_NOTIFICATIONS_TAB_NAME(): string { return 'OPERATOR_NOTIFICATIONS_TAB_NAME' }
    public get OPERATOR_DEPOSITORY_TAB_NAME(): string { return 'OPERATOR_DEPOSITORY_TAB_NAME' }

    private get DEPOSITORY_DETAILS_ACCORDION_NAME(): string { return 'DEPOSITORY_DETAILS_ACCORDION_NAME' }
    private get DEPOSITORY_STATE_ACCORDION_NAME(): string { return 'DEPOSITORY_STATE_ACCORDION_NAME' }
    private get DEVICE_CONFIGURATION_INFO_POPUP_ID(): string { return this.$scope.detailsPopupId + '_DEVICE_CONFIGURATION_INFO_POPUP_ID' }
    private get DEVICE_CONSISTENCY_ACTION_STATUS_POPUP_ID(): string { return this.$scope.detailsPopupId + '_DEVICE_CONSISTENCY_ACTION_STATUS_POPUP_ID' }
    private get OPERATOR_ACCORDION_NAME(): string { return 'OPERATOR_ACCORDION_NAME' }
    private get OPERATOR_TECHNICAL_PERMISSIONS_ACCORDION_NAME(): string { return 'OPERATOR_TECHNICAL_PERMISSIONS_ACCORDION_NAME' }
    private get OPERATOR_TECHNICAL_PERMISSIONS_GRID_EDIT_NAME(): string { return 'OPERATOR_TECHNICAL_PERMISSIONS_GRID_EDIT_NAME' }
    private get OPERATOR_TECHNICAL_PERMISSIONS_GRID_EDIT_POPUP_ID() { return this.$scope.detailsPopupId + '_TECHNICAL_PERMISSIONS_GRID_EDIT_POPUP' }
    private get OPERATOR_TECHNICAL_PERMISSIONS_GRID_NAME(): string { return 'OPERATOR_TECHNICAL_PERMISSIONS_GRID_NAME' }
    private get PERSONAL_DETAILS_ACCORDION_NAME(): string { return 'PERSONAL_DETAILS_ACCORDION_NAME' }
    private get SELECT_POPOVER_POPUP_ID(): string { return this.$scope.detailsPopupId + '_OPEN_SELECT_POPOVER_POPUP' }

    //#endregion


    //#region Members

    private operator: OpOperator
    private idOperator: number

    //#endregion


    //#region Ctor

    constructor(
        $scope: OperatorDetailsScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        localDictionary: LocalDictionaryFactory,
        userSessionService: UserSessionService,
        private depositoryService: DepositoryService,
        private deviceService: DeviceService,
        private operatorService: OperatorService,
        private operatorDepositoryService: OperatorDepositoryService,
        private operatorTechnicalPermissionsService: OperatorTechnicalPermissionsService,
        private systemService: SystemService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $q, null, localDictionary, OperatorLayoutSettings.UserPopupTabActive, userSessionService, referenceType)

        this.initializeActions()
        this.setEvents()
        this.setOptions()
        this.initializeConfirmationPopup()
        this.initializeInfoPopup()
        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_LIST)) {
            this.configureTabs(this.getTabs())
        }
    }

    //#endregion


    //#region Events

    private onClear(): void {
        this.$scope.popupTitle = ''
        this.$scope.showTabs = false

        this.operator = null
        this.idOperator = null

        this.clearBasicParameters()
        this.clearTechnicalPermissions()
        this.clearSecurity()
        this.clearNotifications()
        this.clearDepository()
    }

    private onClose(): void {
        this.hidePopup()
    }

    private onConfirmDelete(): void {
        this.operatorService
            .deleteOperator(this.operator)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
                this.onClose()
            })
    }

    private onDelete(): void {
        this.confirmationPopup.show()
    }

    private onOpen(options: DetailsOptions): void {
        this.onClear()

        this.$scope.detailsOpenParams = options
        this.idOperator = options.referenceObjectId

        this.showPopup()
        this.onRefresh(null)
    }

    private onRefresh(toRefresh: OpOperator = null): void {
        this.$scope.options.isDataLoaded = false

        if (!toRefresh) {
            this.operatorService
                .getOperator(this.idOperator)
                .then((operator: OpOperator) => {
                    return $.when(
                        this.initialize(operator)
                    )
                })
                .fail(() => {
                    this.hidePopup()
                })
                .always(() => {
                    this.$scope.options.isDataLoaded = true
                })
        }
        else {
            $.when(
                this.initialize(toRefresh)
            )
                .always(() => {
                    this.$scope.options.isDataLoaded = true
                })
        }
    }

    private onTabSelected(e: DetailsPopupTabSelectedArgs): void {
        this.updateActions(e.tabName)

        if (e.tabName === this.OPERATOR_DEPOSITORY_TAB_NAME) {
            this.clearDepositoryTab()
        }
    }

    //#endregion


    //#region Initialize

    private initialize(operator: OpOperator): JQueryPromise<void> {
        const def: JQueryDeferred<void> = $.Deferred<void>()

        if (operator != null && (!this.operator || this.operator.idOperator == operator.idOperator)) {
            this.operator = operator

            $.when(
                this.initializeOperator(),
                this.initializeDepository(),
                this.initializeSecurity(),
                this.initializeNotifications(),

                this.updateActions(this.getSelectedTabName())
            ).always(() => {
                def.resolve()
            })

            this.$scope.showTabs = true
        } else {
            def.resolve()
        }

        return def.promise()
    }

    //#endregion


    //#region Actions

    private actions: any[]
    private commonActions: any[] = []
    private depositoryActions: any[] = []

    private initializeActions(): void {
        this.actions = []

        this.commonActions = this.getCommonActionButtons()
        this.depositoryActions = this.getDepositoryActionButtons()

        this.actions.push(...this.commonActions)
    }

    private getCommonActionButtons(): DevExpress.ui.dxButtonOptions[] {
        const commonButtonOptions: DevExpress.ui.dxButtonOptions[] = []

        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_COPY)) {
            commonButtonOptions.push({
                hint: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__COPY, this.moduleName),
                template: TemplateHelper.getIconWithText(
                    LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__COPY, this.moduleName),
                    ConfigHelper.Icon.CONTENT_COPY,
                    this.userSession
                ),
                width: '100%',

                onClick: (e: any) => {
                    this.$scope.$root.$broadcast(
                        EventsNames.INITIALIZE_CREATE_EDIT_POPUP,
                        this.operatorService.getCreateEditOptions(this.idOperator, this.operator, true)
                    )
                },
            })
        }

        return commonButtonOptions
    }

    private updateActions(tabName: string): void {
        this.actions.length = 0
        this.actions.push(...this.commonActions)

        if (tabName === this.OPERATOR_DEPOSITORY_TAB_NAME) {
            this.actions.push(...this.depositoryActions)
        }
    }

    //#endregion


    //#region Confirmation Popup

    public confirmationPopupOptions: IMRConfirmationPopupOptions
    private confirmationPopup: IIMRConfirmationPopup

    private initializeConfirmationPopup(): void {
        this.confirmationPopupOptions = {
            content: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName),
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => {
                this.onConfirmDelete()
            },

            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.confirmationPopup = e.component
            }
        }
    }

    //#endregion


    //#region Depository

    public depositoryParametersOptions: IMRDepositoryParametersOptions
    public depositoryStateItemSwapperPopupOptions: ItemSwapperPopupOptions<OpLocationEquipment>
    public depositoryStateGridOptions: GridOptions
    public infoPopupSource: InfoPopupSource
    public needInfoPopup: boolean
    public treeListOptions: TreeListOptions
    public depositoryEditButtonListPopupOptions: IMRButtonListPopupOptions

    private depositoryStateGrid: GridController<OpLocationEquipment>
    private depositoryStateItemSwapperPopup: IItemSwapperPopup<OpLocationEquipment>
    private depsositoryConsistencyCheckButton: DevExpress.ui.dxButton
    private depsositorySendConfigurationButton: DevExpress.ui.dxButton
    private operatorDepositoryContent: OpLocationEquipment[]
    private selectedDepositoryContent: OpLocationEquipment[]
    private depositoryEditButtonListPopup: IIMRButtonListPopup

    private initializeDepository(): JQueryPromise<void> {
        const def: JQueryDeferred<void> = $.Deferred<void>()

        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_FITTER_DEPOSITORY_VIEW)) {
            $.when(
                this.initializeDepositoryParameters(this.operator),
                this.initializeDepositoryState(this.operator),
                this.initializeDepositoryEditButtons()
            ).always(() => {
                def.resolve()
            })
        } else {
            def.resolve()
        }

        return def.promise()
    }

    private clearDepository(): void {
        this.clearDepositoryTab()

        this.depositoryParametersOptions = null
        this.depositoryStateGridOptions = null
        this.depositoryStateItemSwapperPopupOptions = null
        this.depsositoryConsistencyCheckButton = null
        this.depsositorySendConfigurationButton = null
        this.operatorDepositoryContent = []
        this.selectedDepositoryContent = []
    }

    private clearDepositoryTab(): void {
        this.depositoryStateItemSwapperPopup = null
        this.depositoryStateGrid = null
    }

    private initializeDepositoryParameters(operator: OpOperator): void {
        this.depositoryParametersOptions = null

        this.$timeout(() => {
            this.depositoryParametersOptions = {
                depository: operator.depositoryLocation,
            }
        }, 100)
    }

    private initializeDepositoryState(operator: OpOperator): JQueryPromise<void> {
        this.depositoryStateGridOptions = null

        return this.operatorDepositoryService
            .getOperatorDepositoryContent(operator)
            .then((depositoryContent: OpLocationEquipment[]) => {
                this.operatorDepositoryContent = depositoryContent

                return this.operatorDepositoryService
                    .getDepositoryGridColumns()
                    .then((columns: ColumnModel[]) => {
                        this.depositoryStateGridOptions = {
                            name: "deviceDepository",
                            type: GridTypes.PAGINATED_SMALL,
                            buttonsOptions: {
                                enabled: true,
                                isRefreshButonHidden: true
                            },
                            addCustomFilters: true,
                            needCustomFilter: true,
                            columnsDictionary: columns,
                            allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.DepositoryState),

                            dataSourceParser: this.depositoryService.getLocationEquipmentParser(),
                            dataSource: depositoryContent,

                            onInitialized: (e: any, grid: GridController<OpLocationEquipment>) => {
                                this.depositoryStateGrid = grid
                            },

                            onDataReady: (equipment: OpLocationEquipment[]) => {
                                this.onContentGridDataReady(equipment)
                            },

                            onSelectionChanged: (e: any) => {
                                this.onDepositorySelectionChanged(e)
                            },

                            localStorageVarForSavedEntity: 'deviceDepository'
                        }
                    })
            })
    }

    private initializeDepositoryEditButtons(): void {
        const listItems: IMRButtonListItem[] = [{
            template: BUTTON_COMPONENT_NAME,
            options: {
                text: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADD, Enums.SimaxModuleName.Depository),

                onClick: (e: any) => {
                    this.depositoryService
                        .openCreate()
                        .then((result: CreateEditResult<OpLocation>) => {
                            if (result.status === CreateEditResult.Status.Success) {
                                this.onDepositorySaved(result.object);
                            }
                        });
                }
            }
        }]


        if (this.operator.depositoryLocation != null) {
            listItems.push({
                template: BUTTON_COMPONENT_NAME,
                options: {
                    text: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDIT, Enums.SimaxModuleName.Depository),

                    onClick: (e: any) => {
                        this.depositoryService
                            .openEdit(this.operator.idDepositoryLocation)
                            .then((result: CreateEditResult<OpLocation>) => {
                                if (result.status === CreateEditResult.Status.Success) {
                                    this.onDepositorySaved(result.object);
                                }
                            });
                    }
                }
            } as any)
        }

        listItems.push({
            template: BUTTON_COMPONENT_NAME,
            options: {
                text: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ASSIGN, Enums.SimaxModuleName.Depository),

                onClick: (e: any) => {
                    const selectPopoverSource: SourcePopover = {
                        popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectDepositoryToAssign),
                        selectPopoverSource: {
                            dataTypeId: Enums.DataType.DEPOSITORY_ID,
                            referenceTypeId: Enums.ReferenceType.IdLocation,
                            selectedId: this.operator.idDepositoryLocation,
                            dataIdSourceModule: Enums.WebSimaxModule.Depositories,
                        },

                        onSubmit: (id: number) => {
                            let location: OpLocation = new OpLocation(null)

                            if (this.operator.depositoryLocation == null || (this.operator.depositoryLocation != null && id != this.operator.depositoryLocation.idLocation)) {
                                location.idLocation = id
                            } else {
                                location = this.operator.depositoryLocation
                            }

                            this.onDepositorySaved(location)
                        },
                    }

                    this.$scope.$broadcast(EventsNames.OPEN_SELECT_POPOVER_POPUP + this.SELECT_POPOVER_POPUP_ID, selectPopoverSource)
                }
            }
        } as any)

        this.depositoryEditButtonListPopupOptions = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChoosePlease),
            items: listItems,

            onInitialized: (e: IMRComponentInitializedArgs<IIMRButtonListPopup>) => {
                this.depositoryEditButtonListPopup = e.component
            }
        }
    }

    private initializeDepositoryStateItemSwapper(): JQueryPromise<void> {
        const defer: JQueryDeferred<void> = $.Deferred<void>()

        this.depositoryService
            .getDefaultRewarehousingItemSwapperOptions()
            .then((options: ItemSwapperPopupOptions<OpLocationEquipment>) => {
                options.onSave = (result: ItemSwapperResult<OpLocationEquipment>) => this.onDepositoryStateSave(result)

                options.itemSwapperOptions.rightSelectGridOptions.getSelectedItemDataSourceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string, idDepository: number) => {
                    if (this.depositoryStateItemSwapperPopup != null &&
                        this.depositoryStateItemSwapperPopup.isVisible()
                    ) {
                        return this.userSession
                            .getDataProvider()
                            .Depository
                            .getDepositoryContentFilter(idDepository, columns, pageNbr, pageSize, customWhereClause)
                    }

                    return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
                }

                this.depositoryStateItemSwapperPopupOptions = options
                this.depositoryStateItemSwapperPopupOptions.onInitialized = (itemSwapper: IItemSwapperPopup<OpLocationEquipment>) => {
                    this.depositoryStateItemSwapperPopup = itemSwapper
                    defer.resolve(null)
                }
            })

        return defer.promise()
    }

    private getDepositoryActionButtons(): DevExpress.ui.dxButtonOptions[] {
        const depositoryButtonOptions: DevExpress.ui.dxButtonOptions[] = []

        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_FITTER_DEPOSITORY_VIEW)) {
            if (this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_CONFIGURATION_CONSISTENCY_CHECK_OP)) {
                depositoryButtonOptions.push({
                    hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationConsistencyCheck),
                    template: TemplateHelper.getIconWithText(
                        LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationConsistencyCheck),
                        ConfigHelper.Icon.ACTIONS,
                        this.userSession
                    ),
                    width: '100%',

                    onInitialized: (e: any) => {
                        this.depsositoryConsistencyCheckButton = e.component
                        this.toggleDepositoryActionButtons()
                    },

                    onClick: (e) => {
                        this.checkDeviceConfigurationInconsistency()
                    },
                })
            }

            if (this.userSession.getLoggedOperator().hasPermission(Activity.DEVICE_CONFIGURATION_SEND)) {
                depositoryButtonOptions.push({
                    hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice),
                    template: TemplateHelper.getIconWithText(
                        LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice),
                        ConfigHelper.Icon.DEVICES,
                        this.userSession
                    ),
                    width: '100%',

                    onInitialized: (e: any) => {
                        this.depsositorySendConfigurationButton = e.component
                        this.toggleDepositoryActionButtons()
                    },

                    onClick: (e) => {
                        this.sendDeviceConfiguration()
                    },
                })
            }
        }

        return depositoryButtonOptions
    }

    private toggleDepositoryActionButtons(): void {
        if (this.depsositoryConsistencyCheckButton != null) {
            this.depsositoryConsistencyCheckButton.option('disabled', _.size(this.selectedDepositoryContent) === 0)
        }
        if (this.depsositorySendConfigurationButton != null) {
            this.depsositorySendConfigurationButton.option('disabled', _.size(this.selectedDepositoryContent) === 0)
        }
    }

    private openDepositoryStateItemSwapper(): void {
        if (this.depositoryStateItemSwapperPopup != null) {
            this.setItemSwapperLeftGridDataSource()
            this.depositoryStateItemSwapperPopup.show()
        } else {
            this.initializeDepositoryStateItemSwapper()
                .then(() => {
                    this.setItemSwapperLeftGridDataSource()
                    this.depositoryStateItemSwapperPopup.show()
                })
        }
    }

    private setItemSwapperLeftGridDataSource(): void {
        if (this.depositoryStateItemSwapperPopup != null) {
            this.depositoryStateItemSwapperPopup.itemSwapper.setLeftGridDataSource($.Deferred().resolve(this.operatorDepositoryContent).promise)
        }
    }

    private onContentGridDataReady(locationEquipment: OpLocationEquipment[]): void {
        if (locationEquipment != null) {
            if (this.depositoryStateItemSwapperPopupOptions != null) {
                this.setItemSwapperLeftGridDataSource()
            }
        }
    }

    private onDepositorySelectionChanged(e: any): void {
        this.selectedDepositoryContent = this.depositoryStateGrid.selectedItems;
        this.toggleDepositoryActionButtons()
    }

    private onDepositorySaved(depository: OpLocation): void {
        if (depository != null && depository instanceof OpLocation) {
            if (this.depositoryEditButtonListPopup != null) {
                this.depositoryEditButtonListPopup.hide();
            }

            if (this.operator.idDepositoryLocation !== depository.idLocation) {
                this.systemService.showLoadIndicator()
                this.operatorDepositoryService
                    .saveOperatorDepository(this.operator, depository)
                    .then((operator: OpOperator) => {
                        this.initialize(operator)
                    })
                    .always(() => {
                        this.systemService.hideLoadIndicator()
                    })
            } else {
                this.operator.depositoryLocation = depository

                this.initializeDepository()
            }
        }
    }

    private onDepositoryStateEdit(): void {
        if (this.operator.idDepositoryLocation != null) {
            this.openDepositoryStateItemSwapper()
        }
    }

    private onDepositoryStateSave(result: ItemSwapperResult<OpLocationEquipment>): JQueryPromise<any> {
        return this.depositoryService
            .saveDepositoryEquipment(this.operator.idDepositoryLocation, result)
            .then(() => {
                this.initializeDepositoryState(this.operator)
            })
    }

    private onDepositoryEdit(): void {
        this.depositoryEditButtonListPopup.show()
    }

    //#endregion


    //#region Device Configuration

    private initializeInfoPopup(): void {
        this.infoPopupSource = {
            infoText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationConsistent),
            popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationConsistencyCheck),
        }
    }

    private sendDeviceConfiguration(): void {
        const depositoryDevices: OpDevice[] = this.depositoryStateGrid.selectedItems.map((equipment: OpLocationEquipment) => equipment.device)

        ActionHelper
            .sendDeviceConfiguration(this.userSession.getDataProvider(), depositoryDevices)
            .then((actionStatusOptions: ActionStatusOptions) => {
                this.$scope.$broadcast(EventsNames.SHOW_ACTION_STATUS_POPUP + this.DEVICE_CONSISTENCY_ACTION_STATUS_POPUP_ID, actionStatusOptions)
            })
    }

    private checkDeviceConfigurationInconsistency(): void {
        const serialNumbers: number[] = this.depositoryStateGrid.selectedItems.map((equipment: OpLocationEquipment) => equipment.serialNbr)

        this.systemService.showLoadIndicator()

        this.userSession
            .getDataProvider().Device
            .getDeviceConfigurationInconsistency(serialNumbers)
            .then((dataList: OpData[]) => {
                this.deviceService
                    .getDeviceConfigurationInconsistencyOptions(this.userSession.getDataProvider(), dataList, serialNumbers)
                    .then((treeOptions: any) => {
                        this.needInfoPopup = true
                        this.treeListOptions = treeOptions

                        this.$timeout(() => {
                            this.$scope.$broadcast(EventsNames.OPEN_INFO_POPUP_POPUP + this.DEVICE_CONFIGURATION_INFO_POPUP_ID, dataList, treeOptions)
                        }, 500)
                    })
                    .fail((error: any) => {
                        ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DeviceConfigurationInconsistencyError));

                        LogHelper.error(OperatorService.LOG_PREFIX, error)
                    })
            })
            .always(() => {
                this.systemService.hideLoadIndicator()
            })
    }

    //#endregion


    //#region Notifications

    public operatorDetailsNotificationsOptions: OperatorDetailsNotificationsOptions

    private clearNotifications(): void {
        this.operatorDetailsNotificationsOptions = null
    }

    private initializeNotifications(): void {
        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_NOTIFICATIONS_LIST)
            || this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_SMS_NOTIFICATIONS_LIST)) {

            this.operatorDetailsNotificationsOptions = null

            this.$timeout(() => {
                this.operatorDetailsNotificationsOptions = {
                    operator: this.operator,

                    onOperatorSaved: (e: OperatorDetailsNotificationsOperatorSavedArgs) => {
                        this.operator = e.operator
                        this.operatorDetailsNotificationsOptions.operator = e.operator

                        this.initializeOperator()
                        this.initializeSecurity()
                        this.initializeDepository()
                    }
                }
            }, 100)
        }
    }

    //#endregion


    //#region Parameters

    public operatorParametersOptions: DetailsParametersOptions
    public actorParametersOptions: DetailsParametersOptions
    public popupFor: string

    private clearBasicParameters(): void {
        this.operatorParametersOptions = null
        this.actorParametersOptions = null
    }

    private initializeBasicParameters(operator: OpOperator): JQueryPromise<void> {
        const def: JQueryDeferred<void> = $.Deferred<void>()

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorParameters)) {
            this.popupFor = CommonHelper.user

            $.when(
                this.initializeOperatorBasicParameters(operator),
                this.initializeActorBasicParameters(operator)
            )
                .always(() => {
                    def.resolve()
                })
        } else {
            def.resolve()
        }

        return def.promise()
    }

    private initializeOperatorBasicParameters(operator: OpOperator): JQueryPromise<void> {
        const def: JQueryDeferred<void> = $.Deferred<void>()

        this.operatorService
            .getBasicOperatorParametersDataTypeGroup()
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.operatorParametersOptions = {
                    dataTypes: dataTypeInGroup,
                    referenceType: this.referenceType,
                    referenceObject: operator,
                    useDynamicValues: true,
                    onDataLoaded: () => {
                        def.resolve()
                    }
                }
            })
            .catch(() => {
                def.reject()
            })

        if (this.isAccordionHidden(this.OPERATOR_ACCORDION_NAME)) {
            def.resolve()
        }

        if (this.isAccordionCollapsed(this.$scope.OPERATOR_ACCORDION_NAME)) {
            def.resolve()
        }

        return def.promise()
    }

    private initializeActorBasicParameters(operator: OpOperator): JQueryPromise<void> {
        const def: JQueryDeferred<void> = $.Deferred<void>()

        this.operatorService
            .getBasicActorParametersDataTypeGroup()
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.actorParametersOptions = {
                    dataTypes: dataTypeInGroup,
                    referenceType: Enums.ReferenceType.IdActor,
                    referenceObject: operator.actor,
                    useDynamicValues: true,
                    onDataLoaded: () => {
                        def.resolve()
                    }
                }
            })
            .catch(() => {
                def.reject()
            })

        if (this.isAccordionHidden(this.PERSONAL_DETAILS_ACCORDION_NAME)) {
            def.resolve()
        }

        if (this.isAccordionCollapsed(this.$scope.PERSONAL_DETAILS_ACCORDION_NAME)) {
            def.resolve()
        }

        return def.promise()
    }

    private openOperatorParamsEdit(): void {
        const createEditInitParams: CreateEditInitParams = this.operatorService.getCreateEditOptions(this.operator.idOperator, this.operator)

        createEditInitParams.createEditSelectedTabType = Enums.SimaxCreateEditSelectedTabType.ExtendedParameters

        this.systemService.openCreateEdit(createEditInitParams)
    }

    private openActorParamsEdit(): void {
        const createEditInitParams: CreateEditInitParams = this.operatorService.getCreateEditOptions(this.operator.idOperator, this.operator)

        createEditInitParams.createEditSelectedTabType = Enums.SimaxCreateEditSelectedTabType.BaseParameters

        this.systemService.openCreateEdit(createEditInitParams)
    }

    //#endregion


    //#region Operator

    private initializeOperator(): JQueryPromise<void> {
        return $.when(
            this.initializeTechnicalPermissions(this.operator),
            this.initializeBasicParameters(this.operator)
        )
    }

    //#endregion


    //#region Security

    public operatorDetailsSecurityOptions: OperatorDetailsSecurityOptions

    private clearSecurity(): void {
        this.operatorDetailsSecurityOptions = null
    }

    private initializeSecurity(): void {
        if (
            this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_PERMISSIONS_EFFECTIVE_PERMISSIONS)
            || this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_PERMISSIONS_ROLE_CHOOSE)
            || this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_PERMISSIONS_CUSTOM_PERM_CHOOSE)
        ) {
            this.operatorDetailsSecurityOptions = null

            this.$timeout(() => {
                this.operatorDetailsSecurityOptions = {
                    operator: this.operator,

                    onOperatorSaved: (e: OperatorDetailsSecurityOperatorSavedArgs) => {
                        this.operator = e.operator
                        this.operatorDetailsSecurityOptions.operator = e.operator

                        this.initializeOperator()
                        this.initializeNotifications()
                        this.initializeDepository()
                    }
                }
            }, 100)
        }
    }

    //#endregion


    //#region Technical Permissions

    public technicalPermissionsGridEditOptions: GridBridge
    public technicalPermissionsGridOptions: GridOptions
    public technicalPermissionsGrid: GridController<OpOperatorTechnicalPermission>

    private clearTechnicalPermissions() {
        this.technicalPermissionsGridEditOptions = null
        this.technicalPermissionsGridOptions = null
    }

    private initializeTechnicalPermissions(operator: OpOperator): JQueryPromise<void> {
        const def: JQueryDeferred<void> = $.Deferred<void>()

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorTechnicalPermissions)) {
            this.operatorTechnicalPermissionsService
                .getAvailableTechnicalPermissions()
                .then((technicalPermissions: OpTechnicalPermission[]) => {
                    this.initializeTechnicalPermissionsGrid(operator)
                    this.initializeTechnicalPermissionsGridEdit(operator, technicalPermissions)
                })
                .always(() => {
                    def.resolve()
                })
        } else {
            def.resolve()
        }

        return def.promise()
    }

    private initializeTechnicalPermissionsGrid(operator: OpOperator): void {
        if (this.technicalPermissionsGrid != null) {
            this.technicalPermissionsGrid.setDataSource(operator.operatorTechnicalPermissions)
        }
        else {
            this.technicalPermissionsGridOptions = {
                addCustomFilters: true,
                columnsDictionary: this.operatorTechnicalPermissionsService.getOperatorTechnicalPermissionsGridColumns(),
                dataSource: operator.operatorTechnicalPermissions,
                name: this.OPERATOR_TECHNICAL_PERMISSIONS_GRID_NAME,
                type: GridTypes.PAGINATED_SMALL,

                buttonsOptions: {
                    enabled: true,
                    toggleDetailsRowsButtonVisible: true
                },

                masterDetail: {
                    enabled: false,
                    template: "detail",
                    autoExpandAll: true
                },

                allowColumnReordering: !this.userSession
                    .getLoggedOperator()
                    .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.OperatorTechnicalPermissions),

                onInitialized: (e: any, grid: GridController<OpOperatorTechnicalPermission>) => {
                    this.technicalPermissionsGrid = grid
                },

                onDisposed: () => {
                    this.technicalPermissionsGrid = null
                }
            }
        }

    }

    private initializeTechnicalPermissionsGridEdit(operator: OpOperator, technicalPermissions: OpTechnicalPermission[]): void {
        const operatorTechnicalPermissionsGridObjects: any[] = _.map(operator.operatorTechnicalPermissions, (operatorTechnicalPermission: OpOperatorTechnicalPermission) => {
            return {
                code: operatorTechnicalPermission.technicalPermission.code,
                endTime: operatorTechnicalPermission.endTime,
                id: operatorTechnicalPermission.idOperatorTechnicalPermission,
                idTechnicalPermission: operatorTechnicalPermission.technicalPermission.idTechnicalPermission,
                name: operatorTechnicalPermission.technicalPermission.toString(),
                notes: operatorTechnicalPermission.notes,
                startTime: operatorTechnicalPermission.startTime,
            }
        })

        this.technicalPermissionsGridEditOptions = null

        this.$timeout(() => {
            this.technicalPermissionsGridEditOptions = {
                allowDublicatedRow: true,
                columns: this.operatorTechnicalPermissionsService.getAvailableGridEditColumns(),
                data: technicalPermissions,
                id: this.$scope.modelId,
                items: operatorTechnicalPermissionsGridObjects,
                name: this.OPERATOR_TECHNICAL_PERMISSIONS_GRID_EDIT_NAME,
                popupId: this.OPERATOR_TECHNICAL_PERMISSIONS_GRID_EDIT_POPUP_ID,
                title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__TECHNICAL_PERMISSIONS_EDITING, Enums.SimaxModuleName.Operator),

                allowColumnReordering: !this.userSession
                    .getLoggedOperator()
                    .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.OperatorTechnicalPermissions),

                onBeforeAdd: (technicalPermissionGridObject: any) => {
                    const technicalPermissionGridObjectClone = TypeHelper.clone(technicalPermissionGridObject)

                    technicalPermissionGridObjectClone.startTime = TypeHelper.stripSeconds(new Date())

                    return technicalPermissionGridObjectClone
                },

                onSubmit: (addedItems: any[], removedItems: any[], grid: any) => {
                    const deferred = this.$q.defer<boolean>()

                    this.operatorTechnicalPermissionsService
                        .saveTechnicalPermissionsGridEditResult(operator, addedItems, removedItems, grid)
                        .then((savedOperator: OpOperator) => {
                            this.initialize(savedOperator)

                            deferred.resolve(true)
                        })
                        .fail(() => {
                            deferred.resolve(false)
                        })

                    return deferred.promise
                }
            }
        }, 300)
    }

    private openTechnicalPermissionsGridEdit(): void {
        this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.OPERATOR_TECHNICAL_PERMISSIONS_GRID_EDIT_POPUP_ID, 'operatorTechnicalPermissions')
    }

    //#endregion


    //#region Setup 

    getAccordions(): DetailsAccordion[] {
        const accordions: DetailsAccordion[] = []

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorParameters) ||
            !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ActorParameters)) {

            const items: DetailsAccordionSection[] = []

            if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ActorParameters)) {
                items.push({
                    name: this.PERSONAL_DETAILS_ACCORDION_NAME,
                    showInTab: this.OPERATOR_COMMON_TAB_NAME,
                    showStatus: false,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PersonalDetails),
                    visible: true,

                    canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_EDIT)
                        && !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ActorParameters),

                    editMethod: () => this.openActorParamsEdit(),
                })
            }

            if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorParameters)) {
                items.push({
                    name: this.OPERATOR_ACCORDION_NAME,
                    showInTab: this.OPERATOR_COMMON_TAB_NAME,
                    showStatus: false,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.User),
                    visible: true,

                    canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_EDIT)
                        && !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorParameters),

                    editMethod: () => this.openOperatorParamsEdit(),
                })
            }

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.UserAccordionsSettings, 0, items, true, (component: DevExpress.ui.dxAccordion) => {
                this.$timeout(() => {
                    component.expandItem(1)
                })
            }))
        }

        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_FITTER_DEPOSITORY_VIEW)) {
            const items: DetailsAccordionSection[] = []

            items.push({
                name: this.DEPOSITORY_DETAILS_ACCORDION_NAME,
                showInTab: this.OPERATOR_DEPOSITORY_TAB_NAME,
                showStatus: false,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.StorageDetails),
                visible: true,

                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_FITTER_DEPOSITORY_EDIT),

                editMethod: () => this.onDepositoryEdit(),
            })

            items.push({
                name: this.DEPOSITORY_STATE_ACCORDION_NAME,
                showInTab: this.OPERATOR_DEPOSITORY_TAB_NAME,
                showStatus: true,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.StorageState),
                visible: true,

                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_FITTER_DEPOSITORY_EDIT),

                editMethod: () => this.onDepositoryStateEdit(),
                status: () => {
                    return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstalledCount) + _.size(this.operatorDepositoryContent)
                },
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.UserDepositoryAccordionsSettings, 1, items))
        }

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorTechnicalPermissions, true)) {
            const items: DetailsAccordionSection[] = []

            items.push({
                name: this.OPERATOR_TECHNICAL_PERMISSIONS_ACCORDION_NAME,
                showInTab: this.OPERATOR_COMMON_TAB_NAME,
                showStatus: true,
                title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__TECHNICAL_PERMISSIONS, Enums.SimaxModuleName.Operator),
                visible: true,

                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorTechnicalPermissions, true),

                editMethod: () => {
                    this.openTechnicalPermissionsGridEdit()
                },

                status: () => {
                    return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedCount) + _.size(this.operator.operatorTechnicalPermissions)
                },
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, null, 2, items))
        }

        return accordions
    }

    getTabs(): any[] {
        const tabs: any[] = []

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorParameters)
            || !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorTechnicalPermissions)) {
            tabs.push({
                template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common), ConfigHelper.Icon.HOME, this.userSession),

                name: this.OPERATOR_COMMON_TAB_NAME
            })
        }

        if (
            this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_PERMISSIONS_EFFECTIVE_PERMISSIONS)
            || this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_PERMISSIONS_ROLE_CHOOSE)
            || this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_PERMISSIONS_CUSTOM_PERM_CHOOSE)
        ) {
            tabs.push({
                template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Security), ConfigHelper.Icon.SECURITY, this.userSession),

                name: this.OPERATOR_SECURITY_TAB_NAME
            })
        }

        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_NOTIFICATIONS_LIST)
            || this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_SMS_NOTIFICATIONS_LIST)) {
            tabs.push({
                template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Notifications), ConfigHelper.Icon.NOTIFICATIONS, this.userSession),

                name: this.OPERATOR_NOTIFICATIONS_TAB_NAME
            })
        }

        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_FITTER_DEPOSITORY_VIEW)) {
            tabs.push({
                template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Depository), ConfigHelper.Icon.STORAGE, this.userSession),

                name: this.OPERATOR_DEPOSITORY_TAB_NAME
            })
        }

        return tabs
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => this.onOpen(args[3])
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            () => this.onClose()
        )

        this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => this.onRefresh(args[0]))
    }

    private setOptions(): void {
        this.$scope.options = <DetailsPopupOptions>{
            id: this.$scope.id,

            actions: this.actions,
            closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),
            delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_DEL) ? Activity[Activity.OPERATOR_DEL] : null,
            openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),

            deleteMethod: () => this.onDelete(),
            getAccordionDataMethod: () => this.getAccordionData(),
            getAccordionSelectionMethod: () => this.getAccordionSelection(),
            updateAccordionMethod: (names: any[]) => this.updateAccordions(names),
            onTabSelected: (e: DetailsPopupTabSelectedArgs) => this.onTabSelected(e),
        }
    }

    //#endregion

    resetData() { this.onClear() }//DO USUNIECIA!!! - zastąpić onClear
    loadData(id: number, objects: any[]) { this.onOpen(null) }//DO USUNIECIA!!! - zastąpić onOpen
    updateData(result: any) { this.onRefresh(result) }//DO USUNIECIA!!! - zastąpić onRefresh
}